import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Silence non-error console output in production so tokens, profile data and
// internal state are not exposed through the browser console. Errors and
// warnings are kept for supportability.
if (environment.environment_name === 'prod') {
  console.log = () => undefined;
  console.debug = () => undefined;
  console.info = () => undefined;
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
